import React from "react";
import { Button } from "@chakra-ui/react";
import "../../Animations.css";
import { haptic } from "@/lib/haptic";
import { useUser } from "@/hooks/UseAuthProviders";

interface AdminButtonProps {
  onClick: () => void;
  text?: string;
  disabled?: boolean;
  className?: string;
  backgroundColor?: string;
  textColor?: string;
}

const AdminButton: React.FC<AdminButtonProps> = ({
  onClick,
  text,
  disabled,
  backgroundColor = "var(--color-blue)",
  textColor = "white",
}) => {
  const [isAnimating, setIsAnimating] = React.useState(false);
  const { user } = useUser();

  // Only show button for admin or partner users
  if (!user || (user.role !== "admin" && user.role !== "partner")) {
    return null;
  }

  const handleClick = () => {
    if (disabled) {
      return;
    }
    haptic.soft();
    setIsAnimating(true);
    setTimeout(() => {
      setIsAnimating(false);
      onClick();
    }, 300);
  };

  return (
    <Button
      variant="default"
      onClick={handleClick}
      bg={disabled ? "var(--color-grey-light)" : backgroundColor}
      disabled={disabled}
      rounded={"xl"}
      color={textColor}
      height={"var(--button-height)"}
      fontSize="var(--base-font-size)"
      _focus={{}}
      _active={{}}
      _hover={{}}
      className={`w-full text-center items-center justify-center self-center font-bold break-words flex-shrink-0 ${
        isAnimating ? "press-animation" : ""
      }`}
    >
      {text || "Admin Action"}
    </Button>
  );
};

export default AdminButton; 